import { useState } from "react";
import Button from "../../components/button";
import Modal from "../../components/modal";
import Headline6 from "../../components/headings/Headline6";
import { FormInput } from "../../wrappers/formInput";
import FormHead from "../../components/headings/FromHead";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormAreaInput } from "../../wrappers/formArea";
import DatepickerDefault from "../../components/datepicker";
import { getMilliSec } from "../../utils/EllowUtils";

export type AddUserForm = {
    comment: string;
    date: any;
  };

  interface Props {
    onClose?: any;
    submit?: any;
  }



const  TerminateContractModal: React.FC<Props> = ({submit, onClose}) => {

    const validationSchema = Yup.object({
        // firstName: Yup.string().required("Field is Required"),
        // lastName: Yup.string().required("Field is Required"),
        // designation: Yup.string().required("Field is Required"),
        // email: Yup.string().required("Field is Required"),
      });

    const formOptions = {
        resolver: yupResolver(validationSchema),}

    const { register, handleSubmit, control, reset, setValue, formState } =
    useForm<AddUserForm>(formOptions);

    const Submit = (data: any) => {
      submit(data)
      onClose()
    }

    const handleChange = ( e: any ) => {
        setValue('date', getMilliSec(e))    
    }

    const changeOn = (val: any) => {
        setValue('comment', val)
    }
 
    return (
      <Modal title="Availability" size="xsmall" onClose={onClose}>
          <div className="form-group">
          <Headline6>Are you sure to Continue?</Headline6>
          <form>
            <FormHead> </FormHead>
            <div className="form-group">
              <FormAreaInput<AddUserForm>
                name="comment"
                register={register}
                errors={formState.errors}
                onchange={(e: any) => changeOn(e.target.value)}
                label="Reason for rejection*"
                placeholder="Enter your comment here"
                type="text"
              />
            </div>
            <div>
            <label className="lablel">End Date*</label>
            <DatepickerDefault
              onChange={(e: any) => handleChange(e.value)}
            //   defaultValue={defaultvalues !== '' ? defaultvalues && defaultvalues.contractStartDate && new Date(defaultvalues.contractStartDate) : defaultvalues.contractStartDate && new Date(jobMetadata.contractStartDate)}
            />
            </div>
          {/* </div> */}
          <div className="popupAction">
            <Button variant='secondary'  onClick={onClose}>Cancel</Button>
            <Button variant='primary' onClick={handleSubmit(Submit)} >Continue</Button>
          </div>
          </form>
          </div>

        </Modal>
    )
}
export default  TerminateContractModal